export const VIDEO_PLAYBACK_ROUTE = 'Media.VideoPlayback';
